import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphql } from '../../../../common/useRetriableGraphqlVars';
import { QUERY_GET_SECTION_RVPO_COMMENTS } from '../../../../graphql/queries/infralistComment';

const options = {
  query: QUERY_GET_SECTION_RVPO_COMMENTS,
  mapData: (result) => result.infralistSectionRvpoCommentaries,
  skipQuery: skipIfNull(null)
};

export function useFetchSectionRVPOComments({ infralistId, sectionId }) {
  const response = useRetriableGraphql({
    queryOptions: options,
    variables: {
      infralist_id: infralistId,
      section_id: sectionId
    },
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
  const data = response.state.data;

  return data ?? [];
}
